/*LIBRARY*/
import { Component } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import { set_value_sini_data } from "../../App/actions/sini_data_actions";

/*PICTURE*/

/*FUNCTION*/

/*DATA*/

/*CONST*/

class S_D_GRAPH extends Component {
  state = {};

  on_change = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value });
  };

  render() {
    //local storage

    //local state

    //global props

    //content

    return <main>S_D_GRAPH</main>;
  }
}

const mapStateToProps = (state) => ({
  layer: state.layer,
  project: state.project,
  loading_reducer: state.loading_reducer,
  sini_data_reducer: state.sini_data_reducer,
});

export default connect(mapStateToProps, { set_value_sini_data })(S_D_GRAPH);
